var React = require('react');

function PlayPause (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("g",{"className":"pause","key":1},[React.createElement("rect",{"x":"4.9","width":"5","height":"25","key":0}),React.createElement("rect",{"x":"15.1","width":"5","height":"25","key":1})]),React.createElement("polygon",{"className":"play","points":"6.5,0 19.2,12.7 6.9,25 ","key":2})]);
}

PlayPause.defaultProps = {"version":"1.1","id":"play-pause","x":"0px","y":"0px","viewBox":"0 0 25 25","style":{"enableBackground":"new 0 0 25 25"},"xmlSpace":"preserve"};

module.exports = PlayPause;

PlayPause.default = PlayPause;
